export const FEED = 'feed';
export const PROFILE = 'profile';
export const DETAIL = 'detail';
export const CREATE = 'create';
export const UPDATE = 'update';
export const SEARCH = 'search';
export const NOTIFICATION = 'notification';
export const READING_LIST = 'reading-list';
export const MANAGE = 'manage';
export const GET_STARTED = 'get-started';
export const STUDENT_ROLE = 'STUDENT';
export const PLATFORM_MODERATOR_ROLE = 'PLATFORM_MODERATOR';
export const METADATA_NAMESPACE = 'https://hasura.io/jwt/claims/profile';
